import { h } from 'preact'

export default () => (
  <svg width='169' height='120' viewBox='0 0 169 120' fill='none' xmlns='http://www.w3.org/2000/svg' class='template-icon'>
    <path d='M0 4C0 1.79086 1.79086 0 4 0H165C167.209 0 169 1.79086 169 4V116C169 118.209 167.209 120 165 120H4C1.79086 120 0 118.209 0 116V4Z' fill='#F0F2F8' />
    <rect x='19.5' y='35.5' width='131' height='47' rx='3.5' fill='white' />
    <rect x='28' y='45' width='28' height='28' rx='3' fill='#AB2692' />
    <rect x='66' y='48' width='76' height='8' rx='4' fill='#9599A2' />
    <rect x='66' y='62' width='50' height='6' rx='3' fill='#BFC2C8' />
    <rect x='19.5' y='35.5' width='131' height='47' rx='3.5' stroke='#D5D6DA' />
  </svg>

)
